import { Card, CardContent } from "../../../../components/ui/card";
import { Separator } from "../../../../components/ui/separator";
import { CheckoutItemCard } from "./components/checkout-item-card";
import { CheckoutItemSkeleton } from "./components/checkout-item-skeleton";
import { useEntregoCheckout } from "./hooks/use-entrego-checkout";

export default function EntregoCheckoutResolution() {
  const {
    checkoutList,
    isLoading,
    confirmCheckout,
    startDoc,
    submitRemessa,
    isConfirming,
    isStartingDoc,
    isSubmittingRemessa,
  } = useEntregoCheckout();

  if (isLoading) {
    return (
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-foreground">
            Resolução de Checkout Entrego
          </h1>
          <p className="text-muted-foreground mt-1">
            Resolver pendências dos checkouts de Entrego
          </p>
        </div>
        <div className="space-y-6">
          <CheckoutItemSkeleton />
          <Separator className="my-6" />
          <CheckoutItemSkeleton />
          <Separator className="my-6" />
          <CheckoutItemSkeleton />
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-foreground">
          Resolução de Checkout
        </h1>
        <p className="text-muted-foreground mt-1">
          Resolver pendências dos checkouts de Entrego
        </p>
      </div>

      {checkoutList.length === 0 && !isLoading && (
        <Card>
          <CardContent className="py-12">
            <div className="text-center">
              <h2 className="text-xl font-semibold text-foreground">
                Não há Checkouts de ENTREGO para serem finalizados dos últimos
                20 dias
              </h2>
            </div>
          </CardContent>
        </Card>
      )}

      {!isLoading && checkoutList.length > 0 && (
        <div className="space-y-6">
          {checkoutList.map((checkout, index) => (
            <div key={`${checkout.date_to_checkout}-${index}`}>
              <CheckoutItemCard
                checkout={checkout}
                onConfirmCheckout={(filterDate, ops) =>
                  confirmCheckout({ filterDate, ops })
                }
                // TEMP-SPLIT-OFERTA: PILOTO ENCERRADO (2026-10-02). O piloto passava
                // aqui onEnviarOfertas/isEnviandoOfertas, o que trocava o botão
                // "WhatsApp" por "Registro de Ofertas" + "Enviar Ofertas" (registro
                // sem mensagem para a Rayo, envio num segundo clique). Sem essas
                // props o card volta ao botão WhatsApp: um clique registra e envia
                // a mensagem para todas as franquias. Reativar = repassar as props
                // (enviarOfertas/isEnviandoOfertas do hook) e repovoar
                // ENTREGO_SPLIT_OFFER_OPS no backend.
                onStartDoc={(filterDate, ops) => startDoc({ filterDate, ops })}
                onSubmitRemessa={(filterDate, ops) =>
                  submitRemessa({ filterDate, ops })
                }
                isConfirming={isConfirming}
                isStartingDoc={isStartingDoc}
                isSubmittingRemessa={isSubmittingRemessa}
              />
              {index < checkoutList.length - 1 && (
                <Separator className="my-6" />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
